module.exports = __webpack_public_path__ + "static/img/专密产品推广平台.84307a88.png";